import createReactComponent from '../createReactComponent';
export default createReactComponent('droplet-half', 'IconDropletHalf', [
  ['path', { d: 'M6.8 11a6 6 0 1 0 10.396 0l-5.197 -8l-5.2 8z', key: 'svg-0' }],
  ['path', { d: 'M12 3v17', key: 'svg-1' }],
]);
